<template>
  <loader v-if="loading"/>
  <ibi-content-page v-else />
</template>

<script>
import BaseUI from '@riseupil/base-ui';
import Loader from '@/base-components/Loader';
import IbiContentPage from './IBIContentPage.vue';

export default {
  name: 'IBIInvestmentsPage',
  components: {
    IbiContentPage,
    Loader,
  },
  data() {
    return {
      loading: true,
    };
  },
  computed: {
    ctaProps() {
      return {
        backgroundColor: BaseUI.Colors.riseupLightBlue,
      };
    },
  },
  async created() {
    this.loading = false;
  },
};
</script>

<style scoped lang="scss">
@import "~@riseupil/base-ui/src/scss/riseup-colors";
@import "~@riseupil/base-ui/src/scss/spacings";

.cards-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
